import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ConfirmDialogComponent } from "src/app/services/dialog/confirm-dialog/confirm-dialog.component";
import { AreaMaintenanceService } from "../../area-maintenance/area-maintenance.service";
import { DialogService, HelperService, LanguageService } from "src/app/services";
import { DistrictMaintenanceService } from "../district-maintenance.service";
import { PATTERN_ALPHA_NUMERIC_WITH_SPACE } from "src/app/utils/constant";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { finalize, retry, catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { MediaObserver } from "@angular/flex-layout";
import { of as observableOf } from 'rxjs';
import * as _ from "lodash";

@Component({
  selector: 'esc-district-maintenance-form',
  templateUrl: './district-maintenance-form.component.html',
  styleUrls: ['./district-maintenance-form.component.scss']
})
export class DistrictMaintenanceFormComponent implements OnInit {
  @Input() detail;
  @Input() mode;
  @Output() saving = new EventEmitter();
  @Output() closeForm = new EventEmitter();

  loading = {
    area: false,
    submit: false
  };

  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    private dialogService: DialogService,
    public languageService: LanguageService,
    private areaMntService: AreaMaintenanceService,
    private districtMntSvc: DistrictMaintenanceService
  ) { }

  public getMore = true;
  public areas = [];
  public formGroup: FormGroup;
  public areaRequired;
  public networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  public isFormDisabled = false;

  ngOnInit() {
    this.initForm();
    // console.log(this.mode);
  }

  initForm() {
    this.formGroup = this.fb.group({
      code: [_.get(this.detail, "code"), [Validators.required, Validators.maxLength(20), Validators.pattern(PATTERN_ALPHA_NUMERIC_WITH_SPACE)]],

      description: [_.get(this.detail, "description"), [Validators.required, Validators.maxLength(50)]],

      area: [_.get(this.detail, "area"), [Validators.required]],

      status: _.get(this.detail, "is_active") == 1 ? true : false
    });

    this.toggleDisable();
  }

  toggleDisable() {
    if (!_.get(this.detail, 'id')) {
      this.formGroup.get("status").setValue(true);
      this.formGroup.get("status").disable({ emitEvent: false });
    } 
    else {
      this.formGroup.get("code").disable({ emitEvent: false });
    }
  }

  isFormValid() {
    if(this.formGroup.valid) {
      this.saveChanges()
    }
    else {
      for (let ctrl in this.formGroup.controls) {
        if(!this.formGroup.controls[ctrl].valid) {
          this[ctrl+"Required"] = true;
        }
      }
    }
  }

  saveChanges() {
    this.loading.submit = true;
    this.formGroup.disable();

    let is_active = _.get(this.formGroup.get("status"), "value") ? 1 : 0;

    let obj = {
      data: [
        {
          id: _.get(this.detail, "id") || 0,

          code: _.toUpper(_.get(this.formGroup.get("code"), "value")),

          description: _.toUpper(_.get(this.formGroup.get("description"), "value")),

          area_id: _.get(this.formGroup.get("area"), "value.id"),

          is_active: is_active
        }
      ]
    };
   
    this.saving.emit(true);
    
    this.districtMntSvc.insert(obj).pipe(
        finalize(() => {
          this.loading.submit = false;
          this.saving.emit(false);
          this.formGroup.enable();
          this.toggleDisable();
        })
      )
      .subscribe(
        (res: any) => {
          this.loading.submit = false;
          if (environment.showLogs) {
            console.log(res);
          }
          
          if (_.has(res, 'status') && _.get(res, 'status') == 0) {
            this.helper.networkErrorMessage();
            return;
          }

          if(this.helper.displayErrorMessage(res)) return;
          
          if (_.get(res, 'success.count') > 0) {
            //the ff needs to be an obj to display detail correctly
            obj.data[0]["area"] = _.get(this.formGroup.get("area"), "value");

            this.saving.emit(obj.data);
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DATA_UPDATED", {}));
            this.close(true);
          }
        },
        err => {
          console.log(err);
        }
      );
  }

  disableSaveBtn() {
    return this.loading.submit || (this.formGroup.touched && !this.formGroup.valid)
  }

  confirmChanges() {
    if(this.formGroup.touched && this.formGroup.valid) {
      this.dialogService.openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_SAVE_CHANGES", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if(result) {
          this.saveChanges();
        } else {
          this.close(false);
        }
      })
    }
    else {
      this.close(false);
    }
  }

  getData(ev) {
    let filters = _.get(ev, 'filters')

    /*
    * lagay mo dito kung merong i-cascade na parameters for each field
    */
   
    this[_.get(ev, 'arrayName')] = [];

    this.getMore = false;
   
    switch (_.get(ev, 'name')) {
      case "area": {
        this.loading.area = true;
        this.areaMntService.getList(filters).pipe(
          retry(-1),
          catchError((err) => {
            this.loading.area = false;
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_LOADING", {}));
            return observableOf(err);
          }))
          .subscribe((res: any) => {
            if (environment.showLogs) {
              console.log(res);
            }
            this.loading.area = false;
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            //get more if response isn't empty
            if (_.has(res, 'data') && res.data.length > 0) {
              // gagamitin lang kung may "All"
              // if(!this.formGroup.get('area').value) {
              //   this.areas[0] = this.status[0];
              // }
              this.areas = this.areas.concat(res.data);
              this.getMore = true;
            }
          });
        break;
      }
    }
  }

  areaSelected(ev) {
    // console.log(ev);
    this.formGroup.get('area').setValue(ev);
    this.formGroup.get('area').markAsTouched();
  }

  reset() {
    this.formGroup.reset();
    
    this.formGroup.setValue({
      // LAGAY MO DITO UNG IBANG CONTROLS and default values nila
      area: null,
    })

  }

  close(data) {
    this.closeForm.next(data);
  }

}